import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ReadingAidsChangeboardingModal: LoadableType<{
	onNextClick: () => void;
	modalVersion: 'modal-undefined' | 'modal-word-count';
	contentId: string;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReadingAidsChangeboardingModal" */ '../src/ReadingAidsChangeboardingModal.tsx'
			)
		).ReadingAidsChangeboardingModal,
});
